import React, { useState } from "react";
import { questionCategories } from "./questions_data";
import styles from "./FalQuestions.module.css";

export default function FalQuestions() {
    const [selectedCategoryIndex, setSelectedCategoryIndex] = useState(0);

    return (
        <div className={styles.container}>
            <h1 className={styles.title}>Meriastro Fal Soruları</h1>

            <div className={styles.categoryButtons}>
                {questionCategories.map((category, idx) => {
                    const isActive = selectedCategoryIndex === idx;
                    return (
                        <button
                            key={category.categoryName}
                            onClick={() => setSelectedCategoryIndex(idx)}
                            className={`${styles.categoryButton} ${isActive ? styles.active : styles.inactive
                                }`}
                        >
                            {category.categoryName}
                        </button>
                    );
                })}
            </div>

            <div className={styles.cardGrid}>
                {questionCategories[selectedCategoryIndex].questions.map((q, i) => (
                    <div key={i} className={styles.card}>
                        <span className={styles.cardDot}></span>
                        <h2 className={styles.cardTitle}>{q.text}</h2>
                        <p className={styles.cardPoint}>Puan: {q.point}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}
